import type { RouteRecordRaw } from 'vue-router';
import { AdminRoutes } from '@AdminModule';
import { AuthRoutes } from '@AuthModule';
import { SystemFilterRoutes } from '@FilterModule';
import { ShelterRoutes } from '@ShelterModule';
import { SupportRoutes } from '@SupportModule';

export default <RouteRecordRaw[]>[
  ...AdminRoutes,
  ...AuthRoutes,
  ...ShelterRoutes,
  ...SupportRoutes,
  ...SystemFilterRoutes,
];
